import $ from 'jquery';

export function lang() {
    $(".lang-list__item.active .lang-list__link").attr("href", "javascript:void(0)");
}


// WEBPACK FOOTER //
// app/scripts/components/lang.js